import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse, RoleGroupType } from '../../model';
import {
  IStudioMemberApprovalItem,
  StudioMemberInviteStatus,
} from '../../model/api-modules';
import { STUDIO_PREFIX } from '../config';

// 待审批列表
export const getStudioApproval = (studioId: string, status: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}/approval`;
      const response = await api.commonRequest('GET', url, {
        status,
      });
      const res = await parsedResponse<IStudioMemberApprovalItem[]>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      // if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      return null;
    }
  });

// 工作室管理员审批状态更新
export const postStudioApproval = (
  studioId: string,
  uid: ReadonlyArray<string>,
  status: StudioMemberInviteStatus,
  authType: RoleGroupType,
  authID: Array<number> // 如果是拒绝
) =>
  withAPIAccount(AccountType.auto, async (api): Promise<IAPIresponse> => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}/approval`;
      const response = await api.commonRequest('PUT', url, {
        uid,
        status,
        authType,
        authID,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      // if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      return {};
    }
  });
